export class AppConstants {
  //static readonly SYSTEM_KBN_WITH = "01"; // ウィズのシステム区分

  // ------------------------------------------------------------
  // 操作区分
  static readonly OP_TYPE_LOGOUT = "02"; //操作内容（ログアウト）
  static readonly OP_TYPE_TRANS = "03"; //操作内容（画面遷移）
  static readonly OP_TYPE_VIDEO = "04"; //操作内容（動画再生）
  static readonly OP_TYPE_FILE = "05"; //操作内容（ファイルダウンロード）
  static readonly OP_TYPE_SARCH = "06"; //操作内容（検索）
  static readonly OP_TYPE_RESET_PWD = "07"; //操作内容（パスワードリセット）
  static readonly OP_TYPE_FAVORIT = "08"; //操作内容（お気に入り登録・解除）
  static readonly OP_TYPE_UPDATE_PWD = "09"; //操作内容（パスワード変更）
  static readonly OP_TYPE_VIEW_FILE = "10"; //操作内容（ファイル）
  static readonly OP_TYPE_LINK_CLICK = "11"; //操作内容（リンククリック）
  // ------------------------------------------------------------

  // ------------------------------------------------------------
  // バナー区分
  static readonly BANNER_KBN_CAROUSEL = "01"; //バナー区分（カルーセル）
  static readonly BANNER_KBN_SIDE = "02"; //バナー区分（サイド）
  static readonly BANNER_KBN_KANREN_LINK = "03"; //バナー区分（関連情報リンク）
  static readonly BANNER_KBN_SKILUP_KENSYU = "04"; //バナー区分（研修）
  static readonly BANNER_KBN_LOAD_TO_MASTER = "05"; //バナー区分（Load To Master）
  // ------------------------------------------------------------

  // ------------------------------------------------------------
  // カテゴリ名（権限をチェックするときなどに使う管理用の名称
  static readonly CATEGORY_NAME_INFO = "お知らせ";
  static readonly CATEGORY_NAME_SKILLUP = "スキルアップ";
  static readonly CATEGORY_NAME_ONESTOP_GIDE = "ワンストップガイド";
  static readonly CATEGORY_NAME_FAQ = "よくある質問";
  static readonly CATEGORY_NAME_SHINSEISYO = "申請書";
  static readonly CATEGORY_NAME_TEIANSYO = "提案書";
  static readonly CATEGORY_NAME_TYOHYO_MANUAL = "帳票・マニュアル";
  static readonly CATEGORY_NAME_GYOMU_SHIEN = "業務支援";
  static readonly CATEGORY_NAME_ADMIN_TOP = "管理者TOP";
  static readonly CATEGORY_NAME_AG_USER_TOUROKU = "AG一般ユーザー登録";
  static readonly CATEGORY_NAME_OSHIRASE_TOUROKU = "お知らせ登録";
  static readonly CATEGORY_NAME_AG_SEGMENT_TOUROKU = "AGセグメント登録";
  static readonly CATEGORY_NAME_ADMIN_INFO = "管理者からのお知らせ";
  static readonly CATEGORY_NAME_INCENTIVE = "奨励金";
  static readonly CATEGORY_NAME_TORANOMAKI = "虎の巻";
  static readonly CATEGORY_NAME_EVENT = "イベント";
  static readonly CATEGORY_NAME_LOGIN_POPUP_TOUROKU =
    "ログイン後ポップアップ通知登録";
  static readonly CATEGORY_NAME_LOGIN_POPUP = "ログイン後ポップアップ通知";
  static readonly CATEGORY_NAME_GLOVALNAVI_KANRI = "グローバルナビ管理";
  static readonly CATEGORY_NAME_ICONMENU_KANRI = "アイコンメニュー管理";
  static readonly CATEGORY_NAME_BANNER_KANRI = "バナー登録";
  static readonly CATEGORY_NAME_FAQ_TOUROKU = "FAQ登録";
  static readonly CATEGORY_NAME_SHINSEISYO_TOUROKU = "申請書登録";
  static readonly CATEGORY_NAME_TEIANSYO_TOUROKU = "提案書登録";
  static readonly CATEGORY_NAME_MANUAL_TOUROKU = "帳票・マニュアル登録";
  static readonly CATEGORY_NAME_SKILUP_TOUROKU = "スキルアップ登録";
  static readonly CATEGORY_NAME_EVENT_TOUROKU = "イベント登録";
  static readonly CATEGORY_NAME_EVENT_ENTRY_DL =
    "イベント申込み情報ダウンロード";
  static readonly CATEGORY_NAME_ONESTOP_GIDE_KANRI = "ワンストップガイド管理";
  static readonly CATEGORY_NAME_APP_MGT_AG = "申請管理（申請側）";
  static readonly CATEGORY_NAME_APP_MGT_KAUNET = "申請管理（KAUNET）";
  // ------------------------------------------------------------

  static readonly TOKEN_SESSION_NAME = "with-ag-session-data"; //ローカルストレージに登録するセッション名（トークン）
  static readonly USER_SESSION_NAME = "with-userInfo"; //ローカルストレージに登録するセッション名（ユーザー情報）
  static readonly GROVAL_NAVI_SESSION_NAME = "with-globalnavi"; //ローカルストレージに登録するセッション名（グローバルナビ）
  static readonly PARMITION_SESSION_NAME = "with-parmition"; //ローカルストレージに登録するセッション名（権限情報）
  static readonly SITE_SERCH_CATEGORY_SESSION_NAME = "with-siteserch-category"; //ローカルストレージに登録するセッション名（サイト内検索のカテゴリ）
  static readonly SYSTEMDATE_SESSION_NAME = "with-ag-systemDate"; //ローカルストレージに登録するセッション名（システム日付）
  static readonly INCENTIVE_INFO_SESSION_NAME = "with-incentive-info"; //ローカルストレージに登録するセッション名（インセンティブ情報）
  static readonly BUSINESS_DAYS_SESSION_NAME = "with-ag-business-days"; //ローカルストレージに登録するセッション名（営業日）

  // お知らせ登録の編集モード
  static readonly CONTENTS_EDIT_MODE_NEW = "0";
  static readonly CONTENTS_EDIT_MODE_UPDATE = "1";
  static readonly CONTENTS_EDIT_MODE_COPY = "2";

  // 共通の登録・変更の編集モード
  static readonly EDIT_MODE_NEW = "0"; // 新規登録
  static readonly EDIT_MODE_UPDATE = "1"; // 更新
  static readonly EDIT_MODE_PREVIEW = "9"; // 閲覧

  // 申請状況一覧画面の処理モード
  static readonly PROCESSING_MODE_SERACH = "SERACH"; // 検索条件入力
  static readonly PROCESSING_MODE_RESULT = "RESULT"; // 検索結果表示

  // AG一般ユーザー登録・変更の編集モード
  static readonly AG_USER_EDIT_MODE_NEW = "0"; // 新規登録
  static readonly AG_USER_EDIT_MODE_UPDATE = "1"; // 更新

  // ログイン後ポップアップ通知登録の編集モード
  static readonly LOGIN_POPUP_EDIT_MODE_NEW = "0"; // 新規登録
  static readonly LOGIN_POPUP_EDIT_MODE_UPDATE = "1"; // 更新

  // リッチテキストエディタの空文字
  static readonly QuillEditor_EMPTY = "<p><br></p>";

  // 日付の最大値
  static readonly MAX_DATE_VALUE = "9999-12-31";
  static readonly MAX_DATETIME_VALUE = "9999-12-31T23:59";

  // セッションストレージに登録するセッション名
  static readonly AGUSER_SEARCH_SESSION_NAME = "aguserSearchCond"; // AG一般ユーザー一覧の検索条件
  static readonly AGUSER_REG_SESSION_NAME = "aguserRegParam"; // AG一般ユーザー登録パラメータ
  static readonly CURRENT_PAGE_SESSION_NAME = "withCurrentPage"; // ウィズカウネットの現在ページ
  static readonly LOGIN_POPUP_REG_SESSION_NAME = "loginPopupRegParam"; // ログイン後ポップアップ通知登録パラメータ
  static readonly BANNER_SERCH_SESSION_NAME = "bannerSearchCond"; // バナー一覧の検索条件
  static readonly APPLICATION_MANEGEMENT_SESSION_NAME = "appMgtParam"; // 申請管理パラメータ
  static readonly APPLICATION_MGT_KAUNET_SESSION_NAME = "appMgtKaunetParam"; // 申請管理(受領側)パラメータ
  static readonly APPLICATION_LIST_SESSION_NAME = "appMgtParam"; // 申請一覧パラメータ
  static readonly APPLICATION_LIST_KAUNET_SESSION_NAME = "appMgtKaunetParam"; // 申請一覧(受領側)パラメータ

  // ローカルストレージに登録するセッション名
  static readonly INCENTIVE_SYSTEM_KBN_SESSION_NAME = "withKT7FenA9sxZ69M4"; // 奨励金のシステム区分
  static readonly INCENTIVE_AG_CODE_SESSION_NAME = "withQdCPeRdtH3esr79"; // 奨励金のAGコード
  static readonly INCENTIVE_DAIHYO_CODE_SESSION_NAME = "with3HVkWn5hUEAfNta"; // 奨励金の代表コード
  static readonly INCENTIVE_USER_ID_SESSION_NAME = "withkMXCdrFBMmYP3FQ"; // 奨励金のユーザーID
  static readonly INCENTIVE_TOKEN_SESSION_NAME = "withBiREG5f67ufSupX"; // 奨励金のトークン

  // 申請管理のステータス
  static readonly APP_STATAS_SAVE = "10"; // 申請管理ステータス（一時保存）
  static readonly APP_STATAS_KAUNET_CHECKING = "20"; // カウネット確認中
  static readonly APP_STATAS_AG_CHECKING = "30"; // 申請者確認中
  static readonly APP_STATAS_AG_COMPLETE = "40"; // 完了
  static readonly APP_STATAS_AG_CANCEL = "90"; // 取り下げ
}
